<div class="active-annotate-image"
     [ngClass]="{'draggable': zoomValue > 1}"
     id="activeImage">
  <div class="active-annotate-image__container">
    <canvas id="canvasItem-{{imgIndex}}"></canvas>
  </div>
</div>
